import React, { useEffect } from 'react';

import AbstractScreen from './AbstractScreen';

import { useCarsState } from './../../providers/CarsProvider';

import { getCarsList } from './../../api/cars';

import CarAsset from './../assets/CarAsset';
import ArrowRightFromLineIcon from '../icons/ArrowRightFromLineIcon';

const HomeScreen = () => {

    const [ carsState, carsDispatch ] = useCarsState();

    useEffect( ( ) => {

        getCarsList( "-sort_order" ).then( data => {

            carsDispatch( { type:'updateRootChildList', data } );
        } )
    }, [] )

    return(
        <AbstractScreen className="cover overflow-y-auto d-flex flex-column" id={ 'cars' }>
            <div className="px-1 pt-1 text-center d-flex justify-content-center align-items-center" style={{gap:20}}>
                <h6>Welcome <strong>{ window.props.first_name }</strong></h6>
                <a href="/logout"><ArrowRightFromLineIcon /></a>
            </div>
            <div className="flex-grow-1 d-flex flex-wrap p-1" style={{ gap:8 }}>
               { carsState.rootChildList && carsState.rootChildList.map( carId => (
                    <CarAsset id={ carId } key={`car-${ carId }`} />
               ) ) }
            </div>
        </AbstractScreen>
    )
}

export default HomeScreen;